import { Project } from "@gql/sites-api/graphql";
import { BillingAddressModalProps } from "react-migration/domains/nav/components/Modals/BillingAddressModal";
import { WorkspaceModalSource } from "react-migration/lib/util/logEventV2";
import { proxy } from "valtio/vanilla";

export type NavigationStore = {
  showTopupModal: boolean;
  newProjectModal: { source: WorkspaceModalSource } | null;
  editProjectModal: {
    project: Pick<Project, "id" | "title" | "developmentType" | "goal" | "image" | "imageUrl">;
  } | null;
  topupModalOptions: {
    initialAmount?: number;
  };
  showUpgradeModal: boolean;
  showTrialEndingModal: boolean;
  showMultiDeviceBlockModal: boolean;
  showOverdueInvoiceModal: boolean;
  showDebugModal: boolean;
  showUserColorModal: boolean;
  showImpersonationBanner: boolean;
  showOverdueInvoiceBanner: boolean;
  showBillingAddressModal: boolean;
  billingAddressModalProps: Omit<BillingAddressModalProps, "onClose"> | null;
  addOnsStoreModalPath: string | undefined;
};

const defaultState: NavigationStore = {
  showTopupModal: false,
  newProjectModal: null,
  editProjectModal: null,
  topupModalOptions: {},
  showUpgradeModal: false,
  showTrialEndingModal: false,
  showOverdueInvoiceModal: false,
  showDebugModal: false,
  showUserColorModal: false,
  showMultiDeviceBlockModal: false,
  showImpersonationBanner: false,
  showOverdueInvoiceBanner: true,
  showBillingAddressModal: false,
  billingAddressModalProps: {},
  addOnsStoreModalPath: undefined,
};

export const createNavigationStore = () => defaultState;
export const navigationStore = proxy<NavigationStore>(createNavigationStore());
